export default __webpack_public_path__ + "img/d4cd2f6ccabe4ada44e5257d6ce23ca4.svg";